export const contractsEn = {
  title: 'Contracts',
  create: 'New Contract',
  loading: 'Loading...',
  emptyTitle: 'No contracts',
  emptyDesc: 'You have not created any contracts yet',
  emptyAction: 'Create first contract',
  columns: {
    number: 'Contract No.',
    title: 'Contract Name',
    party: 'Counterparty',
    amount: 'Contract Amount',
    status: 'Status',
    actions: 'Actions',
  },
  actions: {
    view: 'View',
  },
  status: {
    DRAFT: 'Draft',
    PENDING: 'Pending',
    APPROVED: 'Approved',
    REJECTED: 'Rejected',
    SEALED: 'Sealed',
    EXECUTED: 'In Execution',
    EXPIRED: 'Expired',
  },
};

export type ContractsTranslations = typeof contractsEn;
